var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "control" }, [
        _c("input", {
          staticClass: "input",
          class: { "is-danger": _vm.showError },
          attrs: {
            type: "Number",
            step: "any",
            min: _vm.min,
            placeholder: _vm.placeholder,
          },
          domProps: { value: _vm.myValue },
          on: {
            wheel: function ($event) {
              $event.preventDefault()
              return _vm.onScroll.apply(null, arguments)
            },
            input: _vm.myInput,
            blur: _vm.myBlur,
            focus: _vm.focus,
          },
        }),
      ]),
    ]),
    _vm.showError
      ? _c("p", { staticClass: "help is-danger" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }